import { LoginStore } from "@/store/login.store";
import { LoaderStore } from '@/store/loader.store';
import { AuthToken, AuthTokenTimestamp } from "@/utils/auth-valid.util";
import { AcceptorAccountStore } from "@/store/acceptor-account.store";

export abstract class BaseApi {
    protected apiUrl = process.env.VUE_APP_API_URL;
    protected auth = false;
    protected acceptor = false;
    private AUTH_HEADER_KEY = 'X-CC-Auth';

    protected post<Response>(url: string, options?: {
        // eslint-disable-next-line
        payload?: any,
        headers?: Record<string, string>
    }, method: 'POST' | 'PUT' = 'POST'): Promise<Response> {
        return new Promise((resolve, reject) => {
            const post = () => {
                LoaderStore.dispatch('load');
                let headers = options?.headers;
                if (this.auth) {
                    if (!headers) { headers = {}; }
                    headers[this.AUTH_HEADER_KEY] = AuthToken(this.acceptor);
                }
                const body = options?.payload != undefined ? JSON.stringify(options.payload) : undefined;
                const reqInfo: RequestInfo = url;
                const reqInit: RequestInit = {
                    method: method,
                    headers: headers,
                    body: body
                };
                return fetch(reqInfo, reqInit)
                    .then(res => {
                        res.json().then((json) => {
                            LoaderStore.dispatch('done');
                            if (res.status !== 200) {
                                reject(json);
                            } else {
                                resolve(json.data);
                            }
                        });
                    }).catch(error => { LoaderStore.dispatch('done'); reject(error); });
            };
            if (this.auth) {
                this.RefreshToken().then(() => {
                    post();
                }).catch(e => reject(e));
            } else {
                post();
            }
        });
    }

    protected get<Response>(url: string, options?: {
        headers?: Record<string, string>
    }, method: 'GET' | 'DELETE' = 'GET'): Promise<Response> {
        return new Promise((resolve, reject) => {
            const get = () => {
                LoaderStore.dispatch('load');
                let headers = options?.headers;
                if (this.auth) {
                    if (!headers) { headers = {}; }
                    headers[this.AUTH_HEADER_KEY] = AuthToken(this.acceptor);
                }
                const reqInfo: RequestInfo = url;
                const reqInit: RequestInit = {
                    method: method,
                    headers: headers
                };
                return fetch(reqInfo, reqInit)
                    .then(res => {
                        res.json().then((json) => {
                            if (res.status !== 200) {
                                LoaderStore.dispatch('done');
                                reject(json);
                            } else {
                                LoaderStore.dispatch('done');
                                resolve(json.data);
                            }
                        });
                    }).catch(error => { LoaderStore.dispatch('done'); reject(error); });
            };
            if (this.auth) {
                this.RefreshToken().then(() => {
                    get();
                }).catch(e => reject(e));
            } else {
                get();
            }
        });
    }
    protected getFile(url: string, options?: {
        headers?: Record<string, string>
    }, method: 'GET' | 'DELETE' = 'GET'): Promise<Blob> {
        return new Promise((resolve, reject) => {
            const get = () => {
                LoaderStore.dispatch('load');
                let headers = options?.headers;
                if (this.auth) {
                    if (!headers) { headers = {}; }
                    headers[this.AUTH_HEADER_KEY] = AuthToken(this.acceptor);
                }
                const reqInfo: RequestInfo = url;
                const reqInit: RequestInit = {
                    method: method,
                    headers: headers
                };
                return fetch(reqInfo, reqInit)
                    .then(res => {
                        res.blob().then((blob) => {
                            if (res.status !== 200 || blob.size === 0) {
                                LoaderStore.dispatch('done');
                                reject('no-file-found');
                            } else {
                                LoaderStore.dispatch('done');
                                resolve(blob);
                            }
                        });
                    }).catch(error => { LoaderStore.dispatch('done'); reject(error); });
            };
            if (this.auth) {
                this.RefreshToken().then(() => {
                    get();
                }).catch(e => reject(e));
            } else {
                get();
            }
        });
    }

    async RefreshToken(): Promise<void> {
        const authToken = AuthToken(this.acceptor);
        if (AuthTokenTimestamp(this.acceptor)) {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            const reqInfo = `${this.apiUrl}/iam`;
            const reqInit = {
                method: 'GET',
                headers: {
                  /** AUTH_HEADER_KEY */  'X-CC-Auth': authToken
                }
            };
            return fetch(reqInfo, reqInit)
                .then(res => {
                    if (res.status === 401) {
                        localStorage.clear();
                        window.location.replace('/');
                    }
                    res.json().then((json) => {
                        if (res.status !== 200) {
                            LoaderStore.dispatch('done');
                            reject(json);
                        } else {
                            if (this.acceptor === false) {
                                LoginStore.dispatch('updateToken', json.data);
                            } else {
                                AcceptorAccountStore.dispatch('updateAccount', json.data);
                            }
                            LoaderStore.dispatch('done');
                            resolve();
                        }
                    });
                }).catch(error => { LoaderStore.dispatch('done'); reject(error); });
        });

    }

    protected uploadCSV<Response>(url: string, options?: {
        form?: FormData,
        headers?: Record<string, string>
    }, method: 'POST' | 'PUT' = 'POST'): Promise<Response> {
        return new Promise((resolve, reject) => {
            const post = () => {
                LoaderStore.dispatch('load');
                let headers = options?.headers;
                if (this.auth) {
                    if (!headers) { headers = {}; }
                    headers[this.AUTH_HEADER_KEY] = AuthToken(this.acceptor);
                }
                const reqInfo: RequestInfo = url;
                const reqInit: RequestInit = {
                    method: method,
                    headers: headers,
                    body: options?.form
                };
                return fetch(reqInfo, reqInit)
                    .then(res => {
                        res.json().then((json) => {
                            LoaderStore.dispatch('done');
                            if (res.status !== 200) {
                                reject(json);
                            } else {
                                resolve(json.data);
                            }
                        });
                    }).catch(error => { LoaderStore.dispatch('done'); reject(error); });
            };
            if (this.auth) {
                this.RefreshToken().then(() => {
                    post();
                }).catch(e => reject(e));
            } else {
                post();
            }
        });
    }
}

